import React from 'react';
import { grey } from '@mui/material/colors';
import { capitalizeFirstLetter } from 'formatters';
import { Box, Stack, Typography } from '@mui/material';

import { DealSheetRulesTableRow } from '../../types';

interface Props {
  rule: DealSheetRulesTableRow;
  ruleKey: keyof DealSheetRulesTableRow;
}

export const RuleValue = ({ rule, ruleKey }: Props) => {
  if (!rule[ruleKey]) {
    return (
      <Box
        boxShadow={1}
        sx={{
          opacity: '0.5',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block',
          backgroundColor: grey['A100'],
        }}
      >
        <Typography variant="body2">Any</Typography>
      </Box>
    );
  }

  if (Array.isArray(rule[ruleKey])) {
    return (
      <Stack gap="0.5rem" width="100%" alignItems="center">
        {rule[ruleKey].map(value => (
          <Box
            key={value}
            boxShadow={1}
            sx={{
              padding: '2px 8px',
              borderRadius: '4px',
              width: 'fit-content',
              backgroundColor: grey['A100'],
            }}
          >
            <Typography variant="body2">{capitalizeFirstLetter(value)}</Typography>
          </Box>
        ))}
      </Stack>
    );
  }

  return (
    <Box
      boxShadow={1}
      sx={{
        padding: '2px 8px',
        borderRadius: '4px',
        width: 'fit-content',
        backgroundColor: grey['A100'],
      }}
    >
      <Typography variant="body2">{capitalizeFirstLetter(rule[ruleKey])}</Typography>
    </Box>
  );
};
